'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index$1 = require('../../../../../common/theme/index.js');
var index = require('../../../../../common/components/Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const EvaluationIcon = _ref => {
  let {
    action
  } = _ref;
  switch (action) {
    case 'Approve':
      {
        return /*#__PURE__*/React__default["default"].createElement(index["default"], {
          icon: "CheckMarkCircleFilled",
          width: "12",
          height: "12",
          "aria-hidden": true,
          fill: index$1.colors.statusSuccess
        });
      }
    case 'Deny':
      {
        return /*#__PURE__*/React__default["default"].createElement(index["default"], {
          icon: "XCircleFilled",
          width: "12",
          height: "12",
          "aria-hidden": true,
          fill: index$1.colors.statusDanger
        });
      }
    case 'Cancel':
      {
        return /*#__PURE__*/React__default["default"].createElement(index["default"], {
          icon: "IndeterminateCircleFilled",
          width: "12",
          height: "12",
          "aria-hidden": true,
          fill: index$1.colors.statusIndeterminate
        });
      }
    case 'Review':
      {
        return /*#__PURE__*/React__default["default"].createElement(index["default"], {
          icon: "ExclamationCircleFilled",
          width: "12",
          height: "12",
          "aria-hidden": true,
          fill: index$1.colors.statusWarn
        });
      }
    case 'Pending':
      {
        // TODO: Add icon for pending
        return null;
      }
  }
};

exports["default"] = EvaluationIcon;
